import React, { useState } from 'react';
import { Box, Button, TextField, Typography, Paper, Alert, Link } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/api';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    try {
      const response = await authService.forgotPassword(email);
      setSuccess(response.data.message || 'If that email address exists in our system, we will send a password reset link.');
      setEmail('');
    } catch (err) {
      setError(err.response?.data?.message || 'An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f5f5f5' }}>
      <Paper elevation={4} sx={{ p: 4, minWidth: 320, maxWidth: 400 }}>
        <Box 
          component="img" 
          src="/logo.jpg" 
          alt="Logo" 
          sx={{ 
            display: 'block', 
            margin: '0 auto 24px', 
            maxWidth: 120,
            cursor: 'pointer'
          }}
          onClick={() => navigate('/')}
        />
        <Typography variant="h5" gutterBottom align="center">Forgot Password</Typography>
        <Typography variant="body2" color="text.secondary" align="center" sx={{ mb: 3 }}>
          Enter your email address and we'll send you a link to reset your password.
        </Typography>
        
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}
        
        <form onSubmit={handleSubmit}>
          <TextField
            label="Email Address"
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            fullWidth
            margin="normal"
            autoFocus
            required
            autoComplete="email"
            disabled={loading}
          />
          <Button 
            type="submit" 
            variant="contained" 
            color="primary" 
            fullWidth 
            sx={{ mt: 2 }} 
            disabled={loading}
          >
            {loading ? 'Sending...' : 'Send Reset Link'}
          </Button>
        </form>
        
        <Box sx={{ mt: 2, textAlign: 'center' }}>
          <Link 
            component="button" 
            variant="body2" 
            onClick={() => navigate('/login')}
            sx={{ cursor: 'pointer' }}
          >
            Back to Login
          </Link>
        </Box>
        
        <Box sx={{ mt: 1, textAlign: 'center' }}>
          <Link 
            component="button" 
            variant="body2" 
            onClick={() => navigate('/')}
            sx={{ cursor: 'pointer' }}
          >
            Back to Home
          </Link>
        </Box>
      </Paper>
    </Box>
  );
}

